<template>
  <div ref="modal" class="modal fade" :class="{ show: active, 'd-block': active }" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title badge bg-primary">Productivity Month to Date</h5>

          <button type="button" class="btn-close" data-bs-dismiss="modal" v-on:click="$emit('closeModal', null)"
            aria-label="btn-close"></button>
        </div>


        <div class="modal-body">
          <div class="card">

            <div class="card-body">
              <!-- Jakarta -->
              <div class="row mb-3">
                <div class="col-lg-6">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Branch</th>
                        <th>Type of Truck</th>
                        <th>Unit</th>
                        <th>Trip</th>
                        <th>Actual Capacity (Days)</th>
                        <th>Active Day</th>
                        <th>Productivity</th>
                      </tr>
                    </thead>
                    <tbody id="stocksTerminal">
                      <tr v-for="data,index in dataArrayNasional" :key="data.id">
                        <td style="text-align: center;vertical-align:middle;" v-if="(index === 0)" :rowspan="dataArrayNasional.length">Nasional</td>
                        <td><button type="button" class="btn btn-success btn-xs" @click.prevent="openChild(data.truck_category)">{{ data.truck_category }}</button></td>
                        <td style="text-align:right">{{ data.unit }}</td>
                        <td style="text-align:right">{{ data.trip_blujay }}</td>
                        <td style="text-align:right">{{ data.trip }}</td>
                        <td style="text-align:right">{{ data.target_trip }}</td>
                        <td style="text-align:right">{{ data.productivity }} %</td>
                      </tr>
                      <tr>
                        <td colspan="6" style="text-align:center">AVERAGE</td>
                        <td style="text-align:right">{{ avgNasional }} %</td>
                      </tr>
                    </tbody>
                  </table>


                </div>
                <div class="col-lg-6">
                  <LineChartGenerator :chart-options="chartOptions" :chart-data="chartNasional" :chart-id="chartId"
                    :dataset-id-key="datasetIdKey" :plugins="plugins" :css-classes="cssClasses" 
                    :width="width" :height="height" />

                  <div v-if="this.availableChartDataKeSatu"
                    style="text-align: center; left: 0; top: 100px; z-index: 20;color: black;">
                    <b>{{ $t("no_data_available_txt") }}</b>
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <span style="height:80px;">
                  <hr />
                </span>
              </div>

            </div>


          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" v-on:click="$emit('closeModal', null)">
            {{ $t("close_txt") }}
          </button>
        </div>


        <modal-productivity-nasional-child :showModal="showModalNasionalChild" :data="detailDataNasionalChild"
            @closeModalChild="closeChildModal"></modal-productivity-nasional-child>

      </div>
    </div>
  </div>
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';
//import moment from "moment";
import modalProductivityNasionalChild from "@/components/modal/modalProductivityNasionalChild.vue";


import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, LineElement, ArcElement, CategoryScale, LinearScale, PointElement, Filler } from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, LineElement, ArcElement, CategoryScale, LinearScale, PointElement, Filler, ChartDataLabels);


export default {  
  components: {
    LineChartGenerator,
    "modal-productivity-nasional-child": modalProductivityNasionalChild,
  },
  
  name: "DetailProductivity",
  emits: ["closeModal"],
  props: {   
    
    showModal: Boolean,
    data: {},
    chartId: {
      type: String,
      default: 'line-chart',
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 500
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => { }
    },
    plugins: {
      type: Array,
      default: () => { }
    },

    options: {
      tooltips: {
        enabled: false
      },
    },
  },
  watch: {
    showModal: {      
      handler(newVal) {
        // console.log(newVal);
        this.loadItems(newVal);        
        this.active = newVal;
        const body = document.querySelector("body");
        this.showModal
          ? body.classList.add("modal-open")
          : body.classList.remove("modal-open");

      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isLoading: false,
      active: this.showModal,


      showModalNasionalChild :false,
      detailDataNasionalChild:{},


      opens: "center",
      locale: {
        format: "yyyy-mm-dd",
      },
      permision_role: [],
      dataArrayNasional: [],
      countData: [],
      avgNasional:0,
      availableChartDataKeSatu: false,
      chartNasional: {
        labels: [],
        datasets: [
          {
            label: 'Productivity (%)',
            borderColor: '#0eace6',
            backgroundColor: '#0eace6', //#EF8F15'
            data: []
          },
          {
            datalabels: {
              display: function () {
                return '';
              },
            },
            label: 'Target(%)',
            borderColor: '#EF8F15',
            backgroundColor: '#EF8F15', //#EF8F15'
            data: [98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98, 98]
          }
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'right',
            color: 'green',
            formatter: function (value) {
              return Math.round(value) + '%';
            },
            font: {
              weight: 'bold',
              size: 12,
            }
          },

        }
      },

    };
  },
  computed: {
        myStyles() {
            return {
                height: '100%',
                position: 'relative'
            }
        }
    },
  methods: {
    closeChildModal(){
            this.showModalNasionalChild = false;
            this.detailDataNasionalChild = {};
        },
    openChild(truck_category){
      let tgl = this.data['date']; 
      const baseURI = this.$settings.endPointCt + "truck-productivity/dashboard-nasional-child?date=" + tgl + "&truck_category="+ truck_category ;
            return this.$http.get(baseURI).then((response) => {
                this.detailDataNasionalChild = response.data.datas;
                this.showModalNasionalChild = true;
            }).catch(error => {
                if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
                } else {

                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        } else if (error.response.status === 401) {
                            this.$router.push("/authorized-error");
                        } else {
                            this.$router.push('/page-not-found');
                        }
                    }

                }

            });
    },
    submitParent(index, row) {
      this.$emit("closeModal", row);
    },
    loadItems(newVal) {
      if(newVal){
        this.dataArrayNasional = this.data;
        this.chartNasional.labels = this.dataArrayNasional.map(item => item.truck_category);
        this.chartNasional.datasets[0].data = this.dataArrayNasional.map(item => item.productivity);

        let trips = 0;
        let targets = 0;
        for(let item of this.dataArrayNasional){
          trips += Number(item.trip);
          targets += Number(item.target_trip);

        }
        // console.log (i);
        this.avgNasional = (trips/targets * 100).toFixed(1);
       
      }else{
        this.dataArrayNasional = [];
        this.chartNasional.labels = [];
        this.chartNasional.datasets[0].data =[];
      }
          
          
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); 
    },
  },
  mounted() {    
    this.loadItems();
  },
};
</script>

<style scoped>
.blur-content {
  filter: blur(5px);
  pointer-events: none;
}

.modal {
  background: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background: #fff;
  border-radius: 0px;
  border: none;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  padding: 0px;
  width: 120%;
  height: 100%;
  margin-left: -10%;
}
</style>